import React, { useContext, useEffect, useState } from 'react';
import { getAuthorizedPersonsProfile } from '../../../actions';
import { Context } from '../../../defaults';
import { Table } from 'antd';


const SchoolClasses = () => {
    const { dictionary, language } = useContext(Context);
    const [classes, setClasses] = useState();

    useEffect(() => {
        getAuthorizedPersonsProfile().then(({ data }) => setClasses(data.institution.classes));
    }, []);

    const columns = [
        {
            title: `${dictionary?.Letter[language]}`,
            dataIndex: 'letter',
            key: 'letter',
        },
        {
            title: `${dictionary?.Year[language]}`,
            dataIndex: 'year',
            key: 'year',
        }
    ];


    return (
        <React.Fragment>
            <Table columns={columns} dataSource={classes} rowKey='classes' />
        </React.Fragment>
    );
};
export default SchoolClasses